import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import { getPackageById } from '../../../reducers/packages';
import { selectPackage } from '../../../actions/packages';

import './style.scss';


const SelectButton = ({currentPrice, inProgress, onClick}, {currencyConverter}) => {
    const formattedPrice = currencyConverter.convert(currentPrice);
    const btnClassName = classnames('btn-lrg-standard', {'in-progress': inProgress});

    return (
        <>
            <p className="price-label">{formattedPrice}</p>
            <button type="submit" onClick={onClick} className={btnClassName}>
                <I18n k={'gig_page_perseus.packages_table.select'}/>{' '}
            </button>
        </>
    );
};

SelectButton.propTypes = {
    currentPrice: PropTypes.number
};

SelectButton.contextTypes = {
    currencyConverter: PropTypes.object
};

SelectButton.defaultProps = {
    onClick: () => true
};

const mapStateToProps = ({ packages }, ownProps) => {
    const packageData = getPackageById(packages, ownProps.id);

    return {
        currentPrice: packageData.currentPrice,
        inProgress: packages.selectedPackageId === ownProps.id
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onClick: () => {
        dispatch(selectPackage({packageId: ownProps.id}));
    }
});

const SelectButtonConnect = connect(mapStateToProps, mapDispatchToProps)(SelectButton);

const SelectPackage = () => (
    <tr className="select-package">
        <th><I18n k={'gig_page_perseus.packages_table.total'}/></th>
        <td>
            <SelectButtonConnect id={3}/>
        </td>
        <td>
            <SelectButtonConnect id={2}/>
        </td>
        <td>
            <SelectButtonConnect id={1}/>
        </td>
    </tr>
);

export { SelectButton };
export default SelectPackage;
